import { render, staticRenderFns } from "./referral-users.vue?vue&type=template&id=3a10224a&scoped=true"
import script from "./referral-users.vue?vue&type=script&lang=js"
export * from "./referral-users.vue?vue&type=script&lang=js"
import style0 from "./referral-users.vue?vue&type=style&index=0&id=3a10224a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a10224a",
  null
  
)

export default component.exports